'use client';

import { useEffect } from 'react';

const PORTAL_ID = '47453230';
const FORM_ID = '804a6d8f-003e-4878-88ef-3f0e480a3ce8';
const REGION = 'na1';

export default function HubSpotForm() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://js.hsforms.net/forms/embed/${PORTAL_ID}.js`;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="hs-form-frame"
      data-region={REGION}
      data-form-id={FORM_ID}
      data-portal-id={PORTAL_ID}
    />
  );
}
